/** Stocks / ICM 3.0 images on CDN via ICM_IMAGES_URL_V3 */
const ICM_3_0_IMG = process.env.ICM_IMAGES_URL_V3;

export const StocksAssets = {
    mtfIllustration: `${ICM_3_0_IMG}webp/mtf-desktop-illustration.webp`,
    scalperIllustration: `${ICM_3_0_IMG}webp/scalper-desktop-illustration.webp`,
    pricingCardCorner: `${ICM_3_0_IMG}webp/pricing-card-corner.webp`,

    heroSaveBrokerage: `${ICM_3_0_IMG}gif/stocks_hero_save_brokerage.gif`,
} as const;
